import Vue from "vue";
import Component from "./Index.vue";

const Constructor = Vue.extend(Component);

const authLoginModal = options => {
  if (Vue.prototype.$isServer) return;
  const { ...rest } = options;
  const instance = new Constructor({
    propsData: {
      ...rest,
    },
  });

  const id = `authLoginModal`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  // instance.vm.visible = true;

  instance.vm.$on("submit", selecteds => {
    if (instance.submit) {
      instance.submit(selecteds);
    }
  });
  instance.vm.$on("cancel", selecteds => {
    if (instance.cancel) {
      instance.cancel(selecteds);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export default authLoginModal;
